<div class="w-100">
 
  <h2 class="mb-5">Interests</h2>
  <div  class="resume-content">

    {{ interest }}

  </div>
</div>
